import React, { FC, ReactElement, useId, useState } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, ListItemIcon, Menu, MenuItem, MenuItemProps } from '@mui/material';

type CascadeSceneContextMenuItemProps = {
  icon?: ReactElement;
  label: string;
} & Omit<MenuItemProps, 'onMouseEnter' | 'onMouseLeave'>;

const CascadingSceneMenuItem: FC<CascadeSceneContextMenuItemProps> = ({
  icon,
  label,
  children,
  id,
  disabled,
  ...other
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLLIElement | null>(null);
  const menuIsOpen = !!menuAnchorEl;

  const menuItemId = useId();
  const normMenuItemId = id ?? menuItemId;

  return (
    <MenuItem
      {...other}
      sx={[{ display: 'flex' }, menuIsOpen && { backgroundColor: 'action.hover' }]}
      onMouseEnter={(event) => {
        if (!disabled) {
          setMenuAnchorEl(event.currentTarget);
        }
      }}
      onMouseLeave={() => {
        setMenuAnchorEl(null);
      }}
      id={normMenuItemId}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mr: 'auto' }}>
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        {label}
      </Box>
      <NavigateNextIcon sx={{ fontSize: '1.2rem' }} />
      <Menu
        sx={{
          pointerEvents: 'none',
          '& .MuiList-root': {
            pointerEvents: 'auto',
          },
        }}
        slotProps={{ list: { 'aria-labelledby': normMenuItemId } }}
        anchorEl={menuAnchorEl}
        open={menuIsOpen}
        onClose={() => setMenuAnchorEl(null)}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      >
        {children}
      </Menu>
    </MenuItem>
  );
};

export default CascadingSceneMenuItem;
